import { render } from "./DeleteUser.vue?vue&type=template&id=56b3d2a8&scoped=true"
import script from "./DeleteUser.vue?vue&type=script&lang=js"
export * from "./DeleteUser.vue?vue&type=script&lang=js"

import "./DeleteUser.vue?vue&type=style&index=0&id=56b3d2a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b3d2a8"]])

export default __exports__